import React from 'react';
import { observer } from 'mobx-react';
import { TopNav, Button, Dropdown, DropdownToggle, DropdownContent } from '@tencent/spaui';
import Icon from '@tencent/od-icon';
import { Link, withRouter } from 'react-router-dom';
import amsLogo from './images/ams-logo.svg';
import avatar from './images/avatar.png';
import Titlebar from './Titlebar';
import NavSub from './NavSub';
import { canUsePermission } from '@/common/permissions/canUsePermission';
import MsgNotify from '@/pages/agency/notice/message/index';
import { logout } from '@/pages/agency/utils/logout.js';
import Menus from '@/common/menus';
import { MANUAL_LINK } from '@/constants/link';
import _ from 'lodash';
import { withAccount } from '@/business-components/operator/account-context';
import cookie from '@/utils/cookie';
import { AGENCY_UID_COOKIE_NAME } from '@/constants/Constants';
import NoticeBoard from '@/pages/agency/notice/component/NoticeBoard';
import { withPermHoc } from '@/common/permissions/WithPermission.js';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import { isOa } from '@/utils/index';
import AgencySelectMenuItem from '@/common-components/HeaderBar/AgencySelectMenuItem/AgencySelectMenuItem';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';
import { computeGetUrl } from '@/utils';
import { BackMpAgency } from './MpOffline';
import { hasFeatureFlag, hasPurview } from '@/services';
import globalStore from '@/stores';
import { AILogoEntry, isEnableAIAssistant } from '@/ai-assistant';

// 我的卡片
export const MyComponent = withRouter(withAccount((props = {}) => {
  const { value = {}, className, history } = props;
  const hasAccountCenterPermission = canUsePermission('62', Object.keys(value.privilege_list || {}));

  const bm_id = +cookie.get('bm_id');
  const agency_uid = +cookie.get('agency_uid');

  const { agency_login_list = [] } = value;

  let current = {};
  const otherLoginList = agency_login_list.filter((item) => {
    if (item.isBm && item.value === bm_id) {
      current = item;
      return false;
    }
    if (item.value === agency_uid) {
      current = item;
      return false;
    }
    return true;
  });

  return (
    <li className={`${className} has-nav-link spaui-topnav-drop`} id="personal-center-tip1">
      <span className="nav-link nav-user-button" aria-haspopup="menu" role="button" aria-label="展开账户信息">
        <div className="spaui-icon icon-avator">
          <img src={avatar} />
        </div>
        <div className="spaui-text">
          <span>{value.agency_name || value.bm_name}</span>
          <small>员工ID: {value.user_id}</small>
        </div>
        <Icon name="triangle-down-small-outlined" />
      </span>
      <div className="spaui-topnav-menu my-card">
        <div className="feed-item">
          <div className="feed-img">
            <img src={avatar} alt="" />
            <div className="feed-img-icon">
              <i className="icon icon-corner-qq"></i>
            </div>
          </div>
          <div className="feed-info">
            <div className="feed-title">{value.agency_name || value.bm_name}</div>
            <div className="feed-desc">
              <small>{current.id}</small>
              <small className="feed-desc">
                {value.qq_number ? `QQ: ${value.qq_number}` : null}
                {value.qq_number && value.wechat_number ? '/' : null}
                {value.wechat_number ? `微信:${value.wechat_number}` : null}
              </small>
              <small>员工姓名: {value.operator_name}</small>
            </div>
          </div>
        </div>
        {otherLoginList.length !== 0 ? (
          <div className="user-feeds-wrapper">
            <Titlebar title="其他账户" />
            <ul className="feeds user-feeds">
              {otherLoginList.map((x) => (
                <li
                  key={x.value}
                  className="feed-item"
                  onClick={() => {
                    _.values(AGENCY_UID_COOKIE_NAME).forEach((v) => cookie.del(v, null, '/'));
                    if (x.isBm) {
                      window.location.href = computeGetUrl(`/agp/index?bm_id=${x.value}`);
                    } else {
                      window.location.href = computeGetUrl(`/agp/index?agency_uid=${x.value}`);
                    }
                  }}
                  data-report-global="switch-super-agency"
                >
                  <div className="feed-name">{x.label}</div>
                  <div className="feed-desc">{x.id}</div>
                  <span className="feed-tips">
                    切换帐号
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        <div className="my-card-footer">
          {hasAccountCenterPermission ? (
            <Button onClick={() => history.push('/agency/manage-account')} data-report-global="jump-to-manage-account">
              账户中心
            </Button>
          ) : null}
          <i className="spaui-icon spaui-icon-divier" />
          <Button onClick={() => history.push('/agency/personal-center')} data-report-global="jump-to-personal-center">
            个人中心
          </Button>
          <i className="spaui-icon spaui-icon-divier" />
          <Button onClick={() => logout()} data-report-global="logout">退出</Button>
        </div>
      </div>
    </li>
  );
}));

// 间隔线
export const NavDivider = (props = {}) => (
  <li className="nav-divider">
    <span className="spaui-topnav-divider"></span>
  </li>
);

const DOWNLOAD_LIST = [
  {
    label: '服务商下载中心',
    href: '/agency/download/index',
    purview: 21000,
    reportKey: 'download-center',
  },
  {
    label: '日报下载中心',
    href: '/agency/download/dailyreport',
    purview: 1111,
    reportKey: 'download-center-dailyreport',
  },
  {
    label: '工作台下载中心',
    href: '//ad.qq.com/worktable/#/task-center',
    perm: [95, 89],
    reportKey: 'download-center-worktable',
  },
];

export const Download = (props = {}) => {
  const validList = DOWNLOAD_LIST.filter((v) => {
    if (v.perm?.length && !hasPurview(v.perm, 'oneOf')) {
      return false;
    }
    if (v.purview && !hasPurview(v.purview)) {
      return false;
    }
    if (v.enableKey && !hasFeatureFlag(v.enableKey)) {
      return false;
    }
    return true;
  });
  if (!validList.length) {
    return null;
  }

  const renderLink = (data, only = false) => {
    const { label, href, reportKey } = data;
    return href.startsWith('//') ? <a
      key={href}
      className="nav-button"
      href={href}
      target='_blank'
      rel="noreferrer"
      data-mark="guide"
      data-report-global={reportKey}
      id={only ? 'download' : undefined}
    >
      {only ? <Icon name="download-outlined" width={18} height={18} /> : label}
    </a> : <Link
      key={href}
      className="nav-button"
      to={href}
      target='_blank'
      rel="opener"
      data-mark="guide"
      data-report-global={reportKey}
      id={only ? 'download' : undefined}
    >
      {only ? <Icon name="download-outlined" width={18} height={18} /> : label}
    </Link>;
  };
  return <li>
    {validList.length > 1 ? (
      <Dropdown trigger="hover" offsetData={({ top: 8, left: 8 })}>
        <DropdownToggle>
          <div className="download-center-icon" id="download">
            <Icon name="download-outlined" width={18} height={18} />
          </div>
        </DropdownToggle>
        <DropdownContent>
          <div className="download-center-link">
            {validList.map((v) => renderLink(v))}
          </div>
        </DropdownContent>
      </Dropdown>
    ) : renderLink(validList[0], true)
    }
  </li>;
};

// 帮助
export const HelpComponent = (props = {}) => {
  function getUrlArr(arr) {
    return arr.map(({ key, data, href }) => {
      let array = [];
      if (href) {
        array.push(href);
      }
      if (data) {
        array = array.concat(getUrlArr(data));
      }
      return array;
    });
  }

  const { value, className } = props;
  const agency_uid = value.bm_id !== 0 ? value?.agency_list?.map((v) => v.agency_uid).join(',') : value.agency_uid;

  const { pathname } = props.location;
  let str = '';
  const urlObj = {};
  Menus.forEach(({ key, href, data }) => {
    urlObj[key] = [];
    if (key && href) {
      urlObj[key] = [href];
    }
    if (data && data.length > 0) {
      urlObj[key] = [...urlObj[key], ...getUrlArr(data)];
    }
  });

  for (const key in urlObj) {
    if (Object.keys(MANUAL_LINK).indexOf(key) !== -1) {
      urlObj[key] = _.flattenDeep(urlObj[key]);
      if (urlObj[key].some((item) => pathname.indexOf(item) === 0)) {
        str = key;
        break;
      }
    }
  }
  const extraObj = {
    registration: ['/registration'],
    report: ['/workbench/data', '/reports/traffic', '/reports/performance', '/reports/business-analysis', '/reports/cost-data', '/reports/charge-data'],
    manage: ['/admin/rule-config', '/admin/architecture'],
    ucenter: ['/ucenter'],
  };
  for (const item of _.values(extraObj)) {
    if (item.some((i) => pathname.indexOf(i) === 0)) {
      str = 'sale-manage';
      break;
    }
  }

  const operationManual = MANUAL_LINK[str] || MANUAL_LINK.base;
  return (
    <li className={`${className} spaui-topnav-drop`}>
      <a className="nav-button" href="javascript:;">
        {/* <i className="spaui-icon icon-nav-help" /> */}
        <Icon name="help-outlined" width={18} height={18} />
      </a>
      <ul className="spaui-topnav-menu help-card">
        <li className="spaui-topnav-menu-item">
          <a href={operationManual} target="_blank" rel="noreferrer" data-report-global="operation-guide">
            操作手册
          </a>
        </li>
        <li className="spaui-topnav-menu-item">
          <a href="https://docs.qq.com/doc/DZEtrTGppc01sSEtk" target="_blank" rel="noreferrer" data-report-global="common-questions">
            常见问题
          </a>
        </li>
      </ul>
    </li>
  );
};

export const MiniappComponent = (props) => {
  return (
    <li className={'spaui-topnav-drop'}>
      <a className="nav-button" href="javascript:;">
        {/* <i className="spaui-icon icon-nav-phone" /> */}
        <Icon name="mobile-oulined" />
      </a>
      <div className="spaui-topnav-menu qr-card">
        <div className="qrcode-item">
          <div className="qrcode-text">服务商效维客小程序</div>
          <i className="icon-miniapp-qrcode" />
          <div className="qrcode-tip">请使用企业微信扫码，注意切换身份哦。</div>
        </div>
      </div>
    </li>
  );
};

/**
 * @description
 */
export function isContainLink(menu = [], pathname) {
  let ret = false;
  menu.forEach((item) => {
    if (item.match && item.match(pathname)) {
      ret = true;
    } else if (item.href === pathname) {
      ret = true;
    } else if (item.data && isContainLink(item.data, pathname)) {
      ret = true;
    }
  });
  return ret;
}

export function knowlageReport(key) {
  if (key == 'knowledge') {
    const data = {
      behavior: '点击知识按钮',
      page1: '概览',
      realtion_type: 'home',
    };
    reportUserBehaviorCgi({ data });
  }
}

const WithPermissionMsgNotify = withPermHoc(MsgNotify, { oneOf: [41] });

const TopNavBar = observer((props = {}) => {
  const { navBreathingLight } = globalStore;
  const { account, loginStatus, webApi, location } = props;
  const { pathname } = location;
  const { navMenu } = account.siteMap;

  const breathingLightParams = {
    ...account,
    navBreathingLight,
  };

  const navMenuData = navMenu.map((x) => {
    if (!x.data || x.data.length === 0) {
      // 无子级菜单
      return {
        type: 'component',
        key: x.key,
        component: function NavMenusFirst() {
          return <li
            role="presentation"
            onClick={() => knowlageReport(x.key)}
            className={`nav-main-item${pathname === x.href ? ' current' : ''}`}
          >
            {x.target ? (
              <a
                role="button"
                id={x.key}
                data-mark="guide"
                href={x.href}
                rel={x.rel}
                target={x.target}
                className="nav-link"
                data-report-global={`nav.${x.key}`}
              >
                {x.label}
                {x.breathingLight && x.breathingLight(breathingLightParams) && (
                  <div className="breathing-dot">
                    <div className="breathing-dot-box">
                      <div className="breathing-dot-outer">
                        <div className="breathing-dot-inner"></div>
                      </div>
                    </div>
                  </div>
                )}
              </a>
            ) : (
              <Link
                role="button"
                to={x.href}
                className="nav-link"
                id={x.key}
                data-mark="guide"
                data-report-global={`nav.${x.key}`}
              >
                {x.label}
                {x.breathingLight && x.breathingLight(breathingLightParams) && (
                  <div className="breathing-dot">
                    <div className="breathing-dot-box">
                      <div className="breathing-dot-outer">
                        <div className="breathing-dot-inner"></div>
                      </div>
                    </div>
                  </div>
                )}
              </Link>
            )}
          </li>;
        },
      };
    }
    const data = x.data.map((y) => {
      return {
        title: y.label,
        list: (y.data || [])
          .filter((j) => !j.hide)
          .map((j) => {
            return {
              ...j,
              url: j.href,
              desc: j.desc,
              name: j.label,
            };
          }),
      };
    });
    const isContain = isContainLink(x.data, pathname);
    // 默认取第一个，但是过滤掉跳转外的
    const list = data.map((item) => item.list[0]).filter((item) => item?.target !== '_blank');
    const currentPath = x.href || list?.[0]?.url || '';

    return {
      type: 'component',
      key: x.key,
      component: function NavMenus() {
        return (
          <li
            role="presentation"
            className={`nav-main-item nav-item nav-property${isContain ? ' current' : ''}`}
          >
            {list.length === 0 ? (
              <a
                href="javascript:;"
                role="button"
                className="nav-link"
                id={x.key}
                data-mark="guide"
                data-report-global={`nav.${x.key}`}
              >
                {x.label}
                {x.breathingLight && x.breathingLight(breathingLightParams) && (
                  <div className="breathing-dot">
                    <div className="breathing-dot-box">
                      <div className="breathing-dot-outer">
                        <div className="breathing-dot-inner"></div>
                      </div>
                    </div>
                  </div>
                )}
              </a>
            ) : (
              <Link
                to={currentPath}
                role="button"
                className="nav-link"
                id={x.key}
                data-mark="guide"
                data-report-global={`nav.${x.key}`}
              >
                {x.label}
                {x.breathingLight && x.breathingLight(breathingLightParams) && (
                  <div className="breathing-dot">
                    <div className="breathing-dot-box">
                      <div className="breathing-dot-outer">
                        <div className="breathing-dot-inner"></div>
                      </div>
                    </div>
                  </div>
                )}
              </Link>
            )}
            <NavSub {...x} data={data} account={account} />
          </li>
        );
      },
    };
  });

  const rightLists = [
    {
      type: 'component',
      component: NoticeBoard,
    },
    ...(isEnableAIAssistant() ? [
      {
        type: 'component',
        component: AILogoEntry,
        position: 'nav',
      },
    ] : []),
    {
      type: 'component',
      component: BackMpAgency,
    },
    {
      type: 'component',
      component: Download,
      account: props.account,
    },
    {
      type: 'component',
      component: WithPermissionMsgNotify,
    },
    {
      type: 'component',
      component: withRouter(HelpComponent),
      account: props.account,
    },
    {
      type: 'component',
      component: MiniappComponent,
    },
    {
      type: 'component',
      component: NavDivider,
    },
    {
      type: 'component',
      component: MyComponent,
    },
  ];

  // 右侧菜单
  const avatar = loginStatus?.userAvatar?.image || '//ui.qzone.com/80x80';
  let nickname = loginStatus?.accountDisplayName || loginStatus.userDisplayName;
  const userid = `(ID:${loginStatus?.userId})` || ''; // 用户ID
  if (loginStatus?.freeLoginUid) {
    nickname = `${nickname}(免登录)`;
  }

  const topNavData = {
    title: '腾讯营销服务商系统',
    logoUrl: amsLogo,
    list: isOa()
      ? [
        {
          placement: 'left',
          value: '',
          data: [
            ...navMenuData,
            {
              type: 'component',
              component: AgencySelectMenuItem,
            },
          ],
        },
        {
          placement: 'right',
          value: '',
          data: [
            {
              type: 'userinfo',
              txUrl: avatar.replace(/^http:(\/\/.*)/, '$1'),
              nickname: `${nickname}  ${userid}`,
              data: [
                {
                  label: '退出',
                  url: '',
                  onClick: (event) => {
                    window.sessionStorage.removeItem('bearer_token');
                    document.location = webApi.logout().url;
                  },
                },
              ],
            },
          ],
        },
      ]
      : [
        {
          placement: 'left',
          value: '',
          data: navMenuData,
        },
        {
          placement: 'right',
          value: account,
          data: rightLists,
        },
      ],
  };

  return <TopNav className="topnav" theme="light" {...topNavData} />;
});

function mapStateToProps(state, ownProps) {
  return {
    loginStatus: state.loginStatus,
  };
}

export default withApi(connect(mapStateToProps)(withRouter(withAccount(TopNavBar))));
